import React from "react";

const Logo = (props) => {
	const { logo, width } = props;
	return <img alt="Logo" src={process.env.PUBLIC_URL + "/images/" + logo} {...props} width={width} />;
};

export default Logo;
